import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0,
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    'stagingapi.fish3sqls.com',
    'api.fish3sqls.com',
    'fish-api-production.azurewebsites.net',
    'fish-api-staging.azurewebsites.net',
  ],
  // Session Replay
  replaysSessionSampleRate: parseFloat(
    import.meta.env.VITE_REPLAYS_SESSION_SAMPLE_RATE,
  ),
  replaysOnErrorSampleRate: 1.0,
  sendDefaultPii: true,
  // Show unlimited levels of additional data attached to errors, instead of
  // truncating to 3 by default
  normalizeDepth: 0,
});
